import { AnalysisCardData, KnowledgeItem } from "@/common/types/types";
import { Query, MetricData } from "@/common/types/types";

import {
  Shield,
  Clock,
  Eye,
  Gauge,
  Zap,
  SlidersVertical,
  SlidersHorizontal,
  ShieldCheck,
} from "lucide-react";
import { BarChart3, ChartPie, Target } from "lucide-react";

export const defaultKnowledgeItem: KnowledgeItem = {
  id: "kb2",
  name: "LangChain",
  embeddingModelProvider: "google",
  summary: "This is about langchain",
  embeddingModelName: "",
  agents: [{ id: "", name: "" }],
  files: [],
  status: "FAILED",
  departmentName: "",
  documentNumber: "",
  documentDate: "",
};

export const loggedInUser = {
  username: "test_user",
  promptTemplateId: "1234",
  allowedRoles: ["IDB_ADMINS", "IDB_USERS"],
};

export const initialTemplates = [
  {
    id: "1",
    name: "Template One",
    role: ["Developer"],
    task: ["Implement feature X"],
    requirements: "Basic dev skills",
    details: "Use React, TypeScript, Tailwind CSS",
    restrictions: "No external libs",
    format: "JSON",
    examples: "Example prompt",
    createdAt: new Date(2025, 4, 10),
    updatedAt: new Date(2025, 4, 12),
    createdBy: "John",
    agentIds: ["agent-1-id"], // placeholder agent ID
  },
  {
    id: "2",
    name: "Template Two",
    role: ["Manager"],
    task: ["Coordinate timelines"],
    requirements: "Leadership",
    details: "Agile sprints",
    restrictions: "Stay on budget",
    format: "Markdown",
    examples: "Example prompt 2",
    createdAt: new Date(2025, 4, 5),
    updatedAt: new Date(2025, 4, 5),
    createdBy: "Unknown", // add fallback if missing
    agentIds: ["agent-2-id"],
  },
];

export const dummyPromptTemplates = [
  {
    prompt_template_id: "template-1",
    template_name: "Library",
    role: "Librarian",
    requirements: "",
    task: "",
    details: "",
    restrictions: "",
    format: "",
    examples: "",
  },
  {
    prompt_template_id: "template-2",
    template_name: "Marketing",
    role: "Sales Admin, Sales Representative",
    requirements: "",
    task: "",
    details: "",
    restrictions: "",
    format: "",
    examples: "",
  },
  {
    prompt_template_id: "template-3",
    template_name: "Mathematics",
    role: "Teacher",
    requirements: "",
    task: "",
    details: "",
    restrictions: "",
    format: "",
    examples: "",
  },
  {
    prompt_template_id: "template-4",
    template_name: "Data Science",
    role: "Data Scientist, Data Analyst",
    requirements: "",
    task: "",
    details: "",
    restrictions: "",
    format: "",
    examples: "",
  },
  {
    prompt_template_id: "template-5",
    template_name: "JAVA",
    role: "SDE, Spring Developer",
    requirements: "",
    task: "",
    details: "",
    restrictions: "",
    format: "",
    examples: "",
  },
];

export const dummyKnowledgeBases = [
  {
    id: "1",
    name: "LangChain",
    chatType: "QA",
    embeddingLLMType: "string",
    embeddingModelName: "string",
    llmModelType: "string",
    llmModelName: "string",
    temperature: 20,
    maxTokens: 2000,
    sourceType: "Document",
    template: "string",
    roles: [""],
    files: [""],
    webUrl: "string",
    summary: "string",
    created: "string",
    updated: "string",
    size: "string",
  },
  {
    id: "2",
    name: "RAG",
    chatType: "QA",
    embeddingLLMType: "string",
    embeddingModelName: "string",
    llmModelType: "string",
    llmModelName: "string",
    temperature: 20,
    maxTokens: 2000,
    sourceType: "Document",
    template: "string",
    roles: [""],
    files: [""],
    webUrl: "string",
    summary: "string",
    created: "string",
    updated: "string",
    size: "string",
  },
];

// Mock data for knowledge bases
export const mockKnowledgeBases = [
  {
    id: "1",
    name: "General Knowledge",
    description: "General information and facts",
    files: ["general.pdf", "facts.docx"],
  },
  {
    id: "2",
    name: "Product Documentation",
    description: "Product-specific documentation and guides",
    files: ["user-guide.pdf", "api-docs.pdf"],
  },
];

export const mockUsers = [
  { id: "u1", name: "John Doe", email: "john@example.com", role: "Admin" },
  {
    id: "u2",
    name: "Jane Smith",
    email: "jane@example.com",
    role: "Developer",
  },
  {
    id: "u3",
    name: "Mike Johnson",
    email: "mike@example.com",
    role: "Designer",
  },
  {
    id: "u4",
    name: "Emily Clark",
    email: "emily@example.com",
    role: "Manager",
  },
  {
    id: "u5",
    name: "Chris Evans",
    email: "chris@example.com",
    role: "Support",
  },
  { id: "u6", name: "Natalie Lee", email: "natalie@example.com", role: "QA" },
  { id: "u7", name: "David Chen", email: "david@example.com", role: "Sales" },
  {
    id: "u8",
    name: "Olivia Patel",
    email: "olivia@example.com",
    role: "Marketing",
  },
  { id: "u9", name: "Henry Kim", email: "henry@example.com", role: "DevOps" },
  { id: "u10", name: "Sophia Rossi", email: "sophia@example.com", role: "HR" },
];

// Mock users data
export const mockUsersUsermgmt = [
  {
    id: "1",
    name: "Super Admin",
    email: "superadmin@example.com",
    role: "superadmin",
    password: "secret1",
    organizationId: "1",
  },
  {
    id: "2",
    name: "Org Admin",
    email: "admin@example.com",
    role: "admin",
    password: "secret2",
    organizationId: "1",
  },
  {
    id: "3",
    name: "Regular User",
    email: "user@example.com",
    role: "user",
    password: "secret3",
    organizationId: "1",
  },
  {
    id: "4",
    name: "Jane Smith",
    email: "jane@example.com",
    role: "user",
    password: "secret4",
    organizationId: "1",
  },
  {
    id: "5",
    name: "Mark Johnson",
    email: "mark@example.com",
    role: "user",
    password: "secret5",
    organizationId: "2",
  },
];

export const mockOrganizations = [
  { id: "1", name: "Main Organization" },
  { id: "2", name: "Secondary Organization" },
];

export const initialGroups = [
  {
    id: "1",
    name: "Main Group",
    description:
      "Primary group for all core users Primary group for all core users Primary group for all core users Primary group for all core users",
    users: ["u1", "u2", "u3"],
    usersCount: 3,
    createdAt: "2023-01-15",
    level: 0,
    children: [
      {
        id: "1-1",
        name: "Engineering",
        description: "Product engineering team",
        users: ["u4", "u5"],
        usersCount: 2,
        createdAt: "2023-02-10",
        level: 1,
        children: [],
      },
    ],
  },
  {
    id: "2",
    name: "Operations",
    description: "Operations and logistics",
    users: ["u6", "u7", "u8", "u9"],
    usersCount: 4,
    createdAt: "2023-03-05",
    level: 0,
    children: [
      {
        id: "2-1",
        name: "Field Ops",
        description: "On-ground operations",
        users: ["u7"],
        usersCount: 1,
        createdAt: "2023-03-12",
        level: 1,
        children: [],
      },
    ],
  },
  {
    id: "3",
    name: "Marketing",
    description: "Marketing initiatives",
    users: ["u2", "u3"],
    usersCount: 2,
    createdAt: "2023-04-12",
    level: 0,
    children: [],
  },
  {
    id: "4",
    name: "Customer Success",
    description: "Customer onboarding and support",
    users: ["u1", "u10", "u5"],
    usersCount: 3,
    createdAt: "2023-05-19",
    level: 0,
    children: [],
  },
  {
    id: "5",
    name: "HR & Admin",
    description: "Human resources and administration",
    users: ["u8", "u9"],
    usersCount: 2,
    createdAt: "2023-06-20",
    level: 0,
    children: [],
  },
];

export const chatHistory = [
  { id: 1, title: "Chat History UI Design Exa...", isActive: true },
  { id: 2, title: "Code Guidelines Extraction ..." },
  { id: 3, title: "Text Extraction: Source Nee..." },
  { id: 4, title: "Localization Best Practices f..." },
  { id: 5, title: "SWE Agent Problem Refine..." },
];

// defaults.ts

export const RolePermissions = {
  SystemAdmin: [
    "manage_users",
    "manage_orgs",
    "manage_kb",
    "access_playground",
    "access_agents",
    "settings",
    "chat_with_personas",
    "knowledge_store",
    "prompt_templates",
    "query_library",
    "performance_dashboard",
    "user_adoption_insights",
    "feedback_report",
    "prompt_guidance",
    "explainability",
  ],
  OrgAdmin: [
    "manage_users",
    "manage_orgs",
    "manage_groups",
    "manage_kb",
    "view_metrics",
    "access_playground",
    "access_agents",
    "settings",
    "chat_with_personas",
    "knowledge_store",
    "prompt_templates",
    "query_library",
    "prompt_guidance",
    "user_adoption_insights",
    "explainability",
    "feedback_report",
    "performance_dashboard",
  ],
  GroupAdmin: [
    "manage_users",
    "access_playground",
    "access_agents",
    "settings",
    "manage_groups",
    "chat_with_personas",
    "knowledge_store",
    "prompt_templates",
    "prompt_guidance",
    "explainability",
    "query_library",
  ],
  User: [
    "access_playground",
    "access_agents",
    "settings",
    "chat_with_personas",
    "prompt_guidance",
    "manage_groups",
    "explainability",
    "query_library",
    "prompt_templates",
    "knowledge_store",
  ],
};

export const HttpMethods = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export const DefaultHeaders = {
  JSON: {
    "Content-Type": "application/json",
  },
};

// defaults.ts
export const TruncatedOutputLength = 200;

export const ScoreThresholds = {
  low: 33.33,
  medium: 66.66,
};

export const categories = [
  "Housing Loans",
  "Credit Cards",
  "Savings",
  "Investments",
  "Insurance",
];

export const mockQueries: Query[] = [
  {
    id: "1",
    category: "Housing Loans",
    name: "How to apply for a housing loan?",
    keywords: ["housing loan", "apply", "process"],
    content:
      "What are the steps and documents required to apply for a housing loan in our bank?",
  },
  {
    id: "2",
    category: "Housing Loans",
    name: "Eligibility for home loan",
    keywords: ["eligibility", "housing", "income"],
    content:
      "What is the minimum salary or income requirement to get a housing loan approved?",
  },
  {
    id: "3",
    category: "Credit Cards",
    name: "Best credit card for rewards",
    keywords: ["credit card", "rewards", "cashback"],
    content:
      "Which credit card offers the best reward points or cashback benefits?",
  },
  {
    id: "4",
    category: "Savings",
    name: "How to open a savings account?",
    keywords: ["savings account", "open", "documents"],
    content:
      "What is the process to open a new savings account and what documents are required?What is the process to open a new savings account and what documents are requiredWhat is the process to open a new savings account and what documents are requiredWhat is the process to open a new savings account and what documents are required What is the process to open a new savings account and what documents are required",
  },
  {
    id: "5",
    category: "Investments",
    name: "Top investment options",
    keywords: ["investment", "beginners", "mutual funds"],
    content:
      "What are the safest investment plans or mutual funds suitable for beginners?",
  },
  {
    id: "6",
    category: "Insurance",
    name: "Types of life insurance plans",
    keywords: ["insurance", "life", "term plan"],
    content:
      "What different types of life insurance plans are offered and what are their benefits?",
  },
];

export const mockMetrics: MetricData[] = [
  {
    id: "hap-detection",
    titleKey: "HAP Detection",
    descriptionKey: "Hate, Abuse, Profanity",
    icon: Shield,
    type: "io",
    status: "monitoring",
    fields: [
      { value: 19, label: "Input", variant: "destructive" },
      { value: 2, label: "Output", variant: "success" },
    ],
  },
  {
    id: "pii-detection",
    titleKey: "PII Detection",
    descriptionKey: "Personal Information",
    icon: Eye,
    type: "io",
    status: "monitoring",
    fields: [
      { value: 34, label: "Input", variant: "warning" },
      { value: 1, label: "Output", variant: "success" },
    ],
  },
  {
    id: "latency",
    titleKey: "Latency",
    descriptionKey: "This is a new upcoming feature",
    icon: Clock,
    type: "comingsoon",
    badge: "Q4 2024",
  },
  {
    id: "throughput",
    titleKey: "Throughput",
    descriptionKey: "This is a new upcoming feature",
    icon: Gauge,
    type: "comingsoon",
    badge: "Q4 2024",
  },
  {
    id: "token-metrics",
    icon: Zap,
    titleKey: "Token Metrics",
    descriptionKey: "This is a new upcoming feature",
    type: "comingsoon",
    badge: "Q3 2024",
  },
  {
    id: "relevancy-score",
    icon: SlidersHorizontal,
    titleKey: "Relevancy Score",
    descriptionKey: "This is a new upcoming feature",
    type: "comingsoon",
    badge: "Q1 2024",
  },
  {
    id: "precision-score",
    icon: SlidersVertical,
    titleKey: "Precision Score",
    descriptionKey: "This is a new upcoming feature",
    type: "comingsoon",
    badge: "Q2 2024",
  },
  {
    id: "faithfulness-score",
    icon: ShieldCheck,
    titleKey: "Faithfulness Score",
    descriptionKey: "This is a new upcoming feature",
    type: "comingsoon",
    badge: "Q2 2024",
  },
];
export const mockAnalysisData: AnalysisCardData[] = [
  {
    id: "input-sentiment",
    titleKey: "Input Sentiment Analysis",
    subtitleKey: "Incoming message analysis",
    icon: ChartPie,
    status: "active",
    data: [
      { name: "Normal", value: 45, color: "#6366f1", percentage: 45 },
      { name: "Urgency", value: 20, color: "#f59e0b", percentage: 20 },
      { name: "Frustration", value: 15, color: "#ef4444", percentage: 15 },
      { name: "Analysis", value: 12, color: "#10b981", percentage: 12 },
      { name: "Suggestion", value: 8, color: "#8b5cf6", percentage: 8 },
    ],
  },
  {
    id: "output-sentiment",
    titleKey: "Output Sentiment Analysis",
    subtitleKey: "Response message analysis",
    icon: ChartPie,
    status: "active",
    data: [
      { name: "Normal", value: 85, color: "#6366f1", percentage: 85 },
      { name: "Professional", value: 10, color: "#10b981", percentage: 10 },
      { name: "Informal", value: 3, color: "#f59e0b", percentage: 3 },
      { name: "Other", value: 2, color: "#ef4444", percentage: 2 },
    ],
  },
  {
    id: "daily-users",
    titleKey: "Average Daily Users",
    subtitleKey: "Daily active users",
    icon: BarChart3,
    status: "coming_soon",
  },
  {
    id: "daily-queries",
    titleKey: "Average Daily Queries",
    subtitleKey: "Daily query volume",
    icon: Target,
    status: "coming_soon",
  },
];

export const sentimentColors: Record<string, string> = {
  Normal: "#22c55e",
  Urgency: "#ef4444",
  Frustration: "#f97316",
  Suggestion: "#8B5CF6",
  Professional: "#8B5CF6",
  Informal: "#f59e0b",
  Empathetic: "#10b981",
  Encouraging: "#84cc16",
  Error: "#dc2626",
};
